(function() {
    'use strict';

    angular.module('app.centrosCostoTercerNivel', []);
})();
